import {
    Box, Dialog, DialogContent,
    Step,
    StepContent, StepLabel, Stepper, TextField, Typography,
    Card,
    InputAdornment,
    IconButton,
    styled,
} from "@mui/material";
import { useState, useEffect } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { provisioningSteps, validateEastWest } from './utils';
import Button from '../../../../../common/components/button/Button';
import jwt_decode from 'jwt-decode'
import { useSearchParams } from 'react-router-dom';
import { serviceSliceState, setConfiguration } from '../../../../../store/slice/serviceSlice';
import { api_validateAndGenerateM365License } from '../../../../../api/master/masterAPI';
import { executeWithTryCatch, gettingCompanyId, isResponseSuccess } from '../../../../../helpers/HelperFunctions';
import { useSelector } from 'react-redux';
import { useToastContext } from '../../../../../App';
import { useCommonRedux } from '../../../../../store/middlewares/CommonRedux';
import { customerProvisioningStatusesGet, customerProvisioningPowershellScript, getFullyQualifiedDomain } from '../../../../../api/orders/ordersAPI';
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close';
import { getCustomerConfiguration } from "../../../../../api/get/getApi";
import { postDRConfiguration } from "../../../../../api/post/postApi";


const InputDiv = styled('div')`
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px !important;
    padding: 0px;
    margin: 10px 0px;
     & > ${'div'} {
    margin-top: 0;
    margin-bottom: 0;
  }
`


const ValidationAlert = ({ msg }) => {
    return (
        <Card sx={{ borderRadius: '4px', padding: '8px 16px', display: 'flex' }}>
            <Box style={{ marginTop: '8px' }}>
                <CheckCircleIcon sx={{ color: '#2e7d32' }} />
            </Box>
            <Box sx={{ p: 1 }}>
                <span>Successfully Validated</span>
                <div style={{ fontSize: '14px', color: '#666' }}>
                    {msg}
                </div>
            </Box>
        </Card>
    );
};

const resolveCompanyId = (searchParams) => {
    const token = localStorage.getItem('sd_cp.jwt:tkn')
    if (!token) return null
    const decoded = jwt_decode(token)
    return searchParams.get('company_id') || decoded?.company_id
}

const updateLoading = (setState, key, value) => {
    setState((prev) => ({ ...prev, [key]: value }))
}

const domainValidationMsg = [
    "East Domain validated and created successfully!",
    "West Domain validated and created successfully!"
]

export const SemiAutomatedProvisioning = (props) => {

    const [activeStep, setActiveStep] = useState(0);
    const [searchParams] = useSearchParams();
    const serviceState = useSelector(serviceSliceState);
    const { dispatch, state } = useCommonRedux();
    const { toast } = useToastContext();
    const [enableEdit, setEnableEdit] = useState(false);
    const [TId, setTId] = useState(serviceState.configuration?.aadTenantId || '');
    const [isRefreshConfig, setIsRefreshConfig] = useState(false)
    const [enableTenantEdit, setEnableTenantEdit] = useState(false);
    const [originalTId, setOriginalTId] = useState("");
    const [originalDomain, setOriginalDomain] = useState("");

    let intervalId = null
    const [completedSteps, setCompletedSteps] = useState({
        east: '',
        west: '',
        data: null
    });

    const [eastWestDomain, setEastWestDomain] = useState({
        domain_0: '', // east
        domain_1: ''  // west
    });

    const [btnLoading, setBtnLoading] = useState({
        saveLoading: false,
        generateLicenseLoading: false,
        submitLoading: false,
    });

    const handleClose = () => {
        props.setOpen(false);
        setEastWestDomain({ domain_0: '', domain_1: '' });
    };

    const validateAndNext = (step) => {
        if (step === 0) setCompletedSteps(prev => ({ ...prev, east: 'completed' }));
        if (step === 1) setCompletedSteps(prev => ({ ...prev, west: 'completed' }));
    };

    const generateM365License = async () => {
        const valid = validateEastWest(eastWestDomain, activeStep);
        setIsRefreshConfig(true);
        if (!valid) {
            const errorMsg = activeStep === 0 ? "Invalid East domain. Please enter a valid domain" :
                "Invalid West domain. Please enter a valid domain";
            toast.showToast(errorMsg, "error");
            return;
        }
        updateLoading(setBtnLoading, 'saveLoading', true)
        const companyId = resolveCompanyId(searchParams)
        const tenantId = serviceState.configuration?.aadTenantId || TId;

        const payload = {
            companyId,
            tenantId: tenantId.trim(),
            domainWest: activeStep == 1 ? eastWestDomain.domain_1.trim() : "",
            domainEast: eastWestDomain.domain_0.trim(),
            provisionType: 1
        }

        let payloadDRApi = {
            "companyId": companyId,
            "sbcPrefix": state?.currentCompanyDetails?.name.toLowerCase().replace(" ", "-") || "",
            "username": "NA",
            "password": "*",
            "tenantId": tenantId,
            env: process.env.REACT_APP_ENV,
        }

        try {

            if (activeStep == 0) {
                let configResponse = await getCustomerConfiguration(companyId);

                if (!configResponse?.data?.result?.sbcPrefix) {
                    const response = await postDRConfiguration(payloadDRApi);
                    if (!response) throw new Error('DR Configuration failed');
                }

                configResponse = await getCustomerConfiguration(companyId);
                if (!configResponse) throw new Error('Customer configuration fetch failed');

                dispatch(setConfiguration({
                    ...configResponse.data.result,
                    userName: configResponse.data.result.username,
                    aadTenantId: configResponse.data.result.aadTenantId,
                }));
                if (!serviceState?.configuration?.isAppConsented) {
                    setIsRefreshConfig(true);
                    // window.open(configResponse.data.result?.consentUrl, '_blank');
                    window.open(configResponse.data.result?.managementConsentUrl, '_blank');
                }
            }

            if (activeStep == 1) {
                const response = await api_validateAndGenerateM365License(payload);

                if (response.status == 200 && !isRefreshConfig) {
                    validateAndNext(activeStep);
                    setOriginalTId(TId.trim());
                    setOriginalDomain(eastWestDomain[`domain_${activeStep}`].trim());
                    if (activeStep === 0) handleNext();
                    updateLoading(setBtnLoading, 'saveLoading', false);
                    toast.showToast(domainValidationMsg[activeStep], 'success');
                    setEnableEdit(false);
                    setEnableTenantEdit(false);
                    props?.getProvisioningStatus();
                    if (activeStep === 1) {
                        handleClose();
                        props?.goToServiceFunction('list');
                        props?.goToServiceFunction('DRlist');
                    }
                }
            }

            // else if (activeStep === 0) {
            //     setTimeout(() => {
            //         validateEastWestDomain();
            //     }, 25000)
            // }


        } catch (err) {
            if (err?.response?.status == 500) {
                toast.showToast('A server error occurred. Please contact support if the issue continues.', 'error');
            } else { toast.showToast(err.message, 'error') }
            updateLoading(setBtnLoading, 'saveLoading', false)
        }
        // handleGenerateLicenseError
    }


    const validateEastWestDomain = async () => {
        try {

            const companyId = resolveCompanyId(searchParams)
            const tenantId = serviceState.configuration?.aadTenantId || TId;

            const payload = {
                companyId,
                tenantId: tenantId,
                domainWest: activeStep == 1 ? eastWestDomain.domain_1.trim() : "",
                domainEast: eastWestDomain.domain_0.trim(),
                provisionType: 1
            }

            const response = await api_validateAndGenerateM365License(payload);

            if (response?.status == 200) {
                setOriginalTId(TId.trim());
                setOriginalDomain(eastWestDomain[`domain_${activeStep}`].trim());
                setIsRefreshConfig(false);
                updateLoading(setBtnLoading, 'saveLoading', false);
                handleNext();
            }

        } catch (err) {
            if (err?.response?.status == 500) {
                toast.showToast('A server error occurred. Please contact support if the issue continues.', 'error');
            } else { toast.showToast(err.message, 'error') }
            updateLoading(setBtnLoading, 'saveLoading', false)
        }
    }

    const getConfigurationDetails = async () => {
        {
            const response = await getCustomerConfiguration(resolveCompanyId(searchParams))
            if (!isResponseSuccess(response)) return
            const isAppConsented = response.data.result.isAppConsented

            if (isAppConsented) {
                dispatch(setConfiguration(response.data.result))
                // setIsRefreshConfig(false);
                clearInterval(intervalId);
                validateEastWestDomain();
                // toast.showToast(TOAST_MESSAGES.PermissionGranted, 'success')
            } else if (isAppConsented === false) {
                setIsRefreshConfig(false)
                clearInterval(intervalId)
                // toast.showToast(TOAST_MESSAGES.PermissionDeclined, 'error')
            }
            else {
                return
            }
        }
    }

    const handleOnChange = (value, step) => {
        setEastWestDomain((pre) => ({ ...pre, [`domain_${step}`]: value }))
    };


    const getProvisioningStatus = async () => {
        const companyId = gettingCompanyId()

        const response = await getFullyQualifiedDomain({ companyId }, companyId)

        if (response?.data && props?.data.length > 0) {

            const domainEast = response?.data?.domainEast?.trim() || "";
            const domainWest = response?.data?.domainWest?.trim() || "";

            setCompletedSteps({
                data: response?.data,
                east: domainEast,
                west: domainWest
            });

            setEastWestDomain({
                domain_0: domainEast,
                domain_1: domainWest
            });

            setOriginalTId(serviceState.configuration?.aadTenantId || "");
            setOriginalDomain(activeStep === 0 ? domainEast : domainWest);
        }
    };

    const downloadProvisioningScript = async () => {
        try {
            const companyId = gettingCompanyId();
            const response = await customerProvisioningPowershellScript(null, companyId);

            const scriptContent = response?.data;
            if (!scriptContent) {
                console.error("No script content received");
                return;
            }

            // Create a Blob from the script content
            const blob = new Blob([scriptContent], { type: "text/plain" });

            // Create a temporary download link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "TeamsProvisioning.ps1"; // Desired file name
            document.body.appendChild(a);
            a.click();

            // Cleanup
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading script:", error);
        }
    };

    const handleGetConfigError = (error) => {
        // toast.showToast(normalizeApiResponse(error)?.message, 'error')
        setIsRefreshConfig(false)
        clearInterval(intervalId)
    }


    useEffect(() => {
        if (isRefreshConfig) {
            intervalId = setInterval(() => {
                executeWithTryCatch(getConfigurationDetails, handleGetConfigError)
            }, 3000)
        }
        return () => clearInterval(intervalId)
    }, [isRefreshConfig])


    useEffect(() => {
        if (!props?.open) return;
        getProvisioningStatus();
        setOriginalTId(serviceState.configuration?.aadTenantId || '');
        const initialDomain = eastWestDomain[`domain_${activeStep}`]?.trim() || "";
        setOriginalDomain(initialDomain);
    }, [props.open]);

    useEffect(() => {
        const domainValue = eastWestDomain[`domain_${activeStep}`]?.trim() || "";
        // Set original domain ONLY when step first loads
        setOriginalDomain(domainValue);
    }, [activeStep]);

    const isStepCompleted = (index) => {
        if (index === 0) return completedSteps.east;
        if (index === 1) return completedSteps.west;
        return false;
    };

    const handleNext = () => {
        setEnableEdit(false);
        setEnableTenantEdit(false);
        setOriginalTId(TId.trim());
        setOriginalDomain(eastWestDomain[`domain_${activeStep}`]?.trim() || "");

        if (activeStep < provisioningSteps.length - 1) {
            setActiveStep(prev => prev + 1);
        }
    };


    const currentDomain = eastWestDomain[`domain_${activeStep}`]?.trim() || '';

    const isTenantChanged = enableTenantEdit && TId.trim() !== originalTId.trim();
    const isDomainChanged = enableEdit && currentDomain !== originalDomain;
    const changesMade = isTenantChanged || isDomainChanged;
    return (
        <Dialog open={props.open} sx={{ padding: '0px !important' }}>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ padding: '0px', maxWidth: '700px' }}>

                <Box sx={{ display: "flex", justifyContent: 'space-between' }}>
                    <Box sx={{ padding: '20px', background: '#f6f6f6', minWidth: '250px' }}>
                        <h3 style={{ margin: '0px' }}>Semi-Automated (PowerShell) *</h3>
                        <Typography variant="subtitle1">Configure subscriber</Typography>
                        <Box sx={{ maxWidth: 400 }}>
                            <Stepper activeStep={activeStep} orientation="vertical">
                                {provisioningSteps.map((step, index) => (
                                    <Step key={step.label} completed={isStepCompleted(index)}>
                                        <StepLabel
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                if (index == 0) setActiveStep(index);
                                                else if (index == 1 && isStepCompleted(index - 1)) {
                                                    setActiveStep(index)
                                                }
                                            }}>
                                            {`Step ${index + 1}`}</StepLabel>
                                        <StepContent>
                                            <Typography>{step.description}</Typography>
                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                    </Box>

                    <Box sx={{ padding: '20px', minWidth: '300px' }}>
                        <h3 style={{ margin: '0px' }}> Domain Setup</h3>
                        <Typography> {activeStep == 0 ? 'Teams East' : 'Teams West'} *</Typography>

                        {activeStep === 0 && (
                            <>
                                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={() => downloadProvisioningScript()}
                                >
                                    1. Download and execute the powershell script(Click here)
                                </Typography>
                            </>
                        )}
                        <Typography>{activeStep == 0 ? '2' : '1'}. Copy & paste the {activeStep == 0 ? 'teams-east' : 'teams-west'} domain verification record from the script output.</Typography>
                        <InputDiv>

                            <TextField
                                label='Enter TenantId'
                                value={TId}
                                onChange={(e) => setTId(e.target.value)}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                disabled={(isStepCompleted(activeStep) && !enableTenantEdit)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {isStepCompleted(activeStep) && !enableTenantEdit && (
                                                <IconButton
                                                    onClick={() => setEnableTenantEdit(true)}
                                                    aria-label="edit"
                                                    style={{
                                                        float: 'end',
                                                        borderRadius: 0,
                                                        fontSize: '20px',
                                                    }}>
                                                    <EditIcon style={{
                                                        fontSize: '15px',
                                                        verticalAlign: 'end',
                                                        margin: '0 0px 0 0px',
                                                    }} />
                                                </IconButton>
                                            )}

                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </InputDiv>

                        <InputDiv>
                            <TextField
                                label={`Paste ${activeStep === 0 ? 'teams-east' : 'teams-west'} record here`}
                                value={eastWestDomain[`domain_${activeStep}`]}
                                onChange={(e) => handleOnChange(e.target.value, activeStep)}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                disabled={(isStepCompleted(activeStep) && !enableEdit)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {isStepCompleted(activeStep) && !enableEdit && (
                                                <IconButton
                                                    onClick={() => setEnableEdit(true)}
                                                    aria-label="edit"
                                                    style={{
                                                        float: 'end',
                                                        borderRadius: 0,
                                                        fontSize: '20px',
                                                    }}>
                                                    <EditIcon style={{
                                                        fontSize: '15px',
                                                        verticalAlign: 'end',
                                                        margin: '0 0px 0 0px',
                                                    }} />
                                                </IconButton>
                                            )}

                                        </InputAdornment>
                                    ),
                                }}

                            />
                        </InputDiv>
                        {isStepCompleted(activeStep) && !changesMade && (
                            <ValidationAlert msg={domainValidationMsg[activeStep]} />
                        )}

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                            {(!isStepCompleted(activeStep) || changesMade) ? (
                                <Button
                                    variant="contained"
                                    text={activeStep === 0 ? 'Validate & Next' : 'Validate & Complete'}
                                    loading={btnLoading?.saveLoading}
                                    isDisabled={!eastWestDomain[`domain_${activeStep}`]?.trim() || !TId.trim()}
                                    onClick={() => {
                                        generateM365License();
                                    }}
                                />
                            ) : null}
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog >
    );
};
